var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "approval" }, [
    _c("div", { staticClass: "approval_body1" }, [
      _c("div", { staticClass: "approval_title" }, [_vm._v("干部任免审批表")]),
      _vm._v(" "),
      _c(
        "table",
        {
          staticStyle: { "table-layout": "fixed" },
          attrs: {
            border: "1px",
            bordercolor: "#666",
            width: "502px",
            cellspacing: "0"
          }
        },
        [
          _c("tr", [
            _c("td", { attrs: { width: "54px" } }, [
              _c(
                "div",
                { staticClass: "jus_title", on: { click: _vm.doPrint } },
                [_vm._v("姓名")]
              )
            ]),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { width: "70px" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.remRecObj.xingMing,
                    width: 64,
                    height: 32
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { width: "70px" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.remRecObj.xingBie,
                    width: 64,
                    height: 32
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("td", { attrs: { width: "74px" } }, [_vm._v("出生年月（岁）")]),
            _vm._v(" "),
            _c("td", { attrs: { width: "70px" } }, [
              _c("div", [
                _vm._v(_vm._s(_vm.formatDate(_vm.remRecObj.chuShengNianYue)))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.remRecObj.chuShengNianYue,
                      expression: "remRecObj.chuShengNianYue"
                    }
                  ]
                },
                [
                  _vm._v(
                    "（" +
                      _vm._s(_vm.transAge(_vm.remRecObj.chuShengNianYue)) +
                      "岁）"
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "td",
              {
                style: _vm.backgroundStyle,
                attrs: { width: "110px", rowspan: "4" }
              },
              [
                !_vm.remRecObj.zhaoPian
                  ? _c("span", [_vm._v("照 片")])
                  : _vm._e()
              ]
            )
          ]),
          _vm._v(" "),
          _c("tr", [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.remRecObj.minZu,
                    width: 64,
                    height: 32
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.remRecObj.jiGuan,
                    width: 64,
                    height: 32
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.remRecObj.chuShengDi,
                    width: 64,
                    height: 32
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("tr", [
            _vm._m(4),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.formatDate(_vm.remRecObj.ruDangShiJian),
                    width: 64,
                    height: 32
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.formatDate(_vm.remRecObj.canJiaGongZuoShiJian),
                    width: 64,
                    height: 32
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("td", [_vm._v("健康状况")]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.remRecObj.jianKangZhuangKuang,
                    width: 64,
                    height: 32
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("tr", [
            _vm._m(6),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { colspan: "2" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.remRecObj.zhuanYeJiShuZhiWu,
                    width: 118,
                    height: 32
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(7),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { colspan: "2" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.remRecObj.shuXiZhuanYeYouHeZhuanChang,
                    width: 138,
                    height: 32
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("tr", [
            _vm._m(8),
            _vm._v(" "),
            _vm._m(9),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { colspan: "2" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.remRecObj.quanRiZhiJiaoYu_XueLi,
                    width: 118,
                    height: 18
                  }
                }),
                _vm._v(" "),
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.remRecObj.quanRiZhiJiaoYu_XueWei,
                    width: 118,
                    height: 18
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(10),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { colspan: "2" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "l_c",
                    value: _vm.remRecObj.quanRiZhiJiaoYu_XueLi_BiYeYuanXiaoXi,
                    width: 173,
                    height: 18
                  }
                }),
                _vm._v(" "),
                _c("ScaleInput", {
                  attrs: {
                    type: "l_c",
                    value: _vm.remRecObj.quanRiZhiJiaoYu_XueWei_BiYeYuanXiaoXi,
                    width: 173,
                    height: 18
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("tr", [
            _vm._m(11),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { colspan: "2" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.remRecObj.zaiZhiJiaoYu_XueLi,
                    width: 118,
                    height: 18
                  }
                }),
                _vm._v(" "),
                _c("ScaleInput", {
                  attrs: {
                    type: "c_c",
                    value: _vm.remRecObj.zaiZhiJiaoYu_XueWei,
                    width: 118,
                    height: 18
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(12),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { colspan: "2" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "l_c",
                    value: _vm.remRecObj.zaiZhiJiaoYu_XueLi_BiYeYuanXiaoXi,
                    width: 173,
                    height: 18
                  }
                }),
                _vm._v(" "),
                _c("ScaleInput", {
                  attrs: {
                    type: "l_c",
                    value: _vm.remRecObj.zaiZhiJiaoYu_XueWei_BiYeYuanXiaoXi,
                    width: 173,
                    height: 18
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("tr", [
            _vm._m(13),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { colspan: "5" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "l_c",
                    value: _vm.remRecObj.xianRenZhiWu,
                    width: 371,
                    height: 32
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("tr", [
            _vm._m(14),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { colspan: "5" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "l_c",
                    value: _vm.remRecObj.niRenZhiWu,
                    width: 371,
                    height: 32
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("tr", [
            _vm._m(15),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { colspan: "5" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "l_c",
                    value: _vm.remRecObj.niMianZhiWu,
                    width: 371,
                    height: 32
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("tr", { staticStyle: { height: "381px" } }, [
            _c("td", { attrs: { colspan: "7" } }, [
              _vm._m(16),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "450px",
                    height: "381px",
                    float: "right",
                    "padding-top": "4px"
                  }
                },
                [
                  _c("ScaleInputJl", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.jlFom != null && _vm.jlFom.length > 0,
                        expression: "jlFom != null && jlFom.length > 0"
                      }
                    ],
                    attrs: { jlArr: _vm.jlFom, width: 449, height: 371 }
                  }),
                  _vm._v(" "),
                  _c("ScaleInput", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.jlFom == null || _vm.jlFom.length == 0,
                        expression: "jlFom == null || jlFom.length == 0"
                      }
                    ],
                    attrs: {
                      type: "l_t",
                      value: _vm.remRecObj.jianLi,
                      width: 449,
                      height: 371
                    }
                  })
                ],
                1
              )
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "approval_body2" }, [
      _c(
        "table",
        {
          staticStyle: { "table-layout": "fixed" },
          attrs: {
            border: "1px",
            bordercolor: "#666",
            width: "502px",
            cellspacing: "0"
          }
        },
        [
          _vm._m(17),
          _vm._v(" "),
          _c("tr", { staticStyle: { height: "74px" } }, [
            _vm._m(18),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { colspan: "6" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "l_c",
                    value: _vm.remRecObj.jiangChengQingKuang,
                    width: 453,
                    height: 66
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("tr", { staticStyle: { height: "56px" } }, [
            _vm._m(19),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { colspan: "6" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "l_c",
                    value: _vm.remRecObj.nianDuKaoHeJieGuo,
                    width: 453,
                    height: 49
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("tr", { staticStyle: { height: "74px" } }, [
            _vm._m(20),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { colspan: "6" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "l_c",
                    value: _vm.remRecObj.renMianLiYou,
                    width: 453,
                    height: 66
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("tr", { staticStyle: { height: "36px" } }, [
            _c("td", { attrs: { rowspan: _vm.familyShowLinesNum + 1 } }, [
              _c(
                "div",
                {
                  staticStyle: {
                    height: "230px",
                    width: "14px",
                    "writing-mode": "vertical-lr",
                    margin: "auto",
                    "letter-spacing": "3px"
                  }
                },
                [
                  _vm._v(
                    "\n              家庭主要成员及重要社会关系\n            "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(21),
            _vm._v(" "),
            _vm._m(22),
            _vm._v(" "),
            _vm._m(23),
            _vm._v(" "),
            _vm._m(24),
            _vm._v(" "),
            _vm._m(25)
          ]),
          _vm._v(" "),
          _vm._l(_vm.familyShowLinesNum, function(item, index) {
            return _c(
              "tr",
              {
                style: {
                  height: _vm.familyEntryAllH / _vm.familyShowLinesNum + "px"
                }
              },
              [
                _c(
                  "td",
                  [
                    _c("ScaleInput", {
                      attrs: {
                        type: "c_c",
                        value: _vm.familyMembers[index].chengWei,
                        width: 52,
                        height: _vm.familyEntryAllH / _vm.familyShowLinesNum - 6
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("ScaleInput", {
                      attrs: {
                        type: "c_c",
                        value: _vm.familyMembers[index].xingMing,
                        width: 60,
                        height: _vm.familyEntryAllH / _vm.familyShowLinesNum - 6
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("ScaleInput", {
                      attrs: {
                        type: "c_c",
                        value: _vm.transAge(
                          _vm.familyMembers[index].chuShengRiQi
                        ),
                        width: 24,
                        height: _vm.familyEntryAllH / _vm.familyShowLinesNum - 6
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c("ScaleInput", {
                      attrs: {
                        type: "c_c",
                        value: _vm.familyMembers[index].zhengZhiMianMao,
                        width: 48,
                        height: _vm.familyEntryAllH / _vm.familyShowLinesNum - 6
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { attrs: { colspan: "2" } },
                  [
                    _c("ScaleInput", {
                      attrs: {
                        type: "l_c",
                        value: _vm.familyMembers[index].gongZuoDanWeiJiZhiWu,
                        width: 245,
                        height: _vm.familyEntryAllH / _vm.familyShowLinesNum - 6
                      }
                    })
                  ],
                  1
                )
              ]
            )
          }),
          _vm._v(" "),
          _c("tr", { staticStyle: { height: "78px" } }, [
            _vm._m(26),
            _vm._v(" "),
            _c(
              "td",
              { attrs: { colspan: "6" } },
              [
                _c("ScaleInput", {
                  attrs: {
                    type: "l_c",
                    value: _vm.remRecObj.chengBaoDanWei,
                    width: 453,
                    height: 40
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "date_view" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.fillFormTime[0]) +
                      "\n              "
                  ),
                  _c("span", [_vm._v("年")]),
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.fillFormTime[1]) +
                      "\n              "
                  ),
                  !_vm.fillFormTime[0] || _vm.fillFormTime[1]
                    ? _c("span", [_vm._v("月")])
                    : _vm._e(),
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.fillFormTime[2]) +
                      "\n              "
                  ),
                  !_vm.fillFormTime[0] || _vm.fillFormTime[2]
                    ? _c("span", [_vm._v("日")])
                    : _vm._e()
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(27)
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fillform_p" }, [
        _vm._v("填表人：" + _vm._s(_vm.remRecObj.tianBiaoRen))
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { width: "54px" } }, [
      _c("div", { staticClass: "jus_title" }, [_vm._v("性别")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("div", { staticClass: "jus_title" }, [_vm._v("民族")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("div", { staticClass: "jus_title" }, [_vm._v("籍贯")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "div",
        { staticClass: "jus_title", staticStyle: { padding: "0 7px" } },
        [_vm._v("出生地")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("div", { staticClass: "jus_title" }, [_vm._v("入党")]),
      _vm._v(" "),
      _c("div", { staticClass: "jus_title" }, [_vm._v("时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("div", { staticClass: "jus_title" }, [_vm._v("参加工")]),
      _vm._v(" "),
      _c("div", { staticClass: "jus_title" }, [_vm._v("作时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("div", { staticClass: "jus_title" }, [_vm._v("专业技")]),
      _vm._v(" "),
      _c("div", { staticClass: "jus_title" }, [_vm._v("术职务")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_vm._v("熟悉专业"), _c("br"), _vm._v("有何特长")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { rowspan: "2" } }, [
      _c("div", { staticClass: "jus_title" }, [_vm._v("学历")]),
      _vm._v(" "),
      _c("div", { staticClass: "jus_title" }, [_vm._v("学位")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticStyle: { padding: "0 7px" } }, [
      _c("div", { staticClass: "jus_title" }, [_vm._v("全日制")]),
      _vm._v(" "),
      _c("div", { staticClass: "jus_title" }, [_vm._v("教育")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_vm._v("毕业院校"), _c("br"), _vm._v("系及专业")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticStyle: { padding: "0 7px" } }, [
      _c("div", { staticClass: "jus_title" }, [_vm._v("在职")]),
      _vm._v(" "),
      _c("div", { staticClass: "jus_title" }, [_vm._v("教育")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_vm._v("毕业院校"), _c("br"), _vm._v("系及专业")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "2" } }, [
      _c("div", { staticClass: "jus_title" }, [_vm._v("现任职务")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "2" } }, [
      _c("div", { staticClass: "jus_title" }, [_vm._v("拟任职务")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "2" } }, [
      _c("div", { staticClass: "jus_title" }, [_vm._v("拟免职务")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "jianli_title" }, [
      _c("div", [_vm._v("简")]),
      _vm._v(" "),
      _c("div", [_vm._v("历")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "table2_first_row" }, [
      _c("td", { attrs: { width: "40px" } }),
      _vm._v(" "),
      _c("td", { attrs: { width: "58px" } }),
      _vm._v(" "),
      _c("td", { attrs: { width: "66px" } }),
      _vm._v(" "),
      _c("td", { attrs: { width: "30px" } }),
      _vm._v(" "),
      _c("td", { attrs: { width: "54px" } }),
      _vm._v(" "),
      _c("td", { attrs: { width: "40px" } }),
      _vm._v(" "),
      _c("td", { attrs: { width: "211px" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "div",
        {
          staticStyle: {
            height: "70px",
            width: "14px",
            "writing-mode": "vertical-lr",
            margin: "auto",
            "letter-spacing": "2px"
          }
        },
        [_vm._v("奖惩情况")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "div",
        {
          staticStyle: {
            height: "50px",
            width: "30px",
            margin: "auto",
            "writing-mode": "vertical-lr",
            "letter-spacing": "2px"
          }
        },
        [_vm._v("年度考核结果\n            ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "div",
        {
          staticStyle: {
            height: "70px",
            width: "14px",
            "writing-mode": "vertical-lr",
            margin: "auto",
            "letter-spacing": "2px"
          }
        },
        [_vm._v("任免理由")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "div",
        { staticClass: "jus_title", staticStyle: { padding: "0 8px" } },
        [_vm._v("称谓")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "div",
        { staticClass: "jus_title", staticStyle: { padding: "0 8px" } },
        [_vm._v("姓名")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "div",
        { staticStyle: { "writing-mode": "vertical-lr", margin: "auto" } },
        [_vm._v("年龄")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "div",
        { staticClass: "jus_title", staticStyle: { padding: "0 8px" } },
        [_vm._v("政治")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "jus_title", staticStyle: { padding: "0 8px" } },
        [_vm._v("面貌")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "2" } }, [
      _c("div", { staticStyle: { "letter-spacing": "8px" } }, [
        _vm._v("工作单位及职务")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c(
        "div",
        {
          staticStyle: {
            height: "70px",
            width: "14px",
            "writing-mode": "vertical-lr",
            margin: "auto",
            "letter-spacing": "2px"
          }
        },
        [_vm._v("呈报单位")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticStyle: { height: "78px" } }, [
      _c("td", [
        _c(
          "div",
          {
            staticStyle: {
              height: "70px",
              width: "30px",
              "writing-mode": "vertical-lr",
              margin: "auto",
              "letter-spacing": "3px",
              "text-align-last": "justify"
            }
          },
          [
            _vm._v("\n              审批机关"),
            _c("br"),
            _vm._v("意见\n            ")
          ]
        )
      ]),
      _vm._v(" "),
      _c("td", { attrs: { colspan: "4" } }, [
        _c("div", { staticStyle: { height: "20px" } }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "text-align": "right",
              "letter-spacing": "3px",
              "padding-right": "21px",
              "margin-bottom": "5px"
            }
          },
          [_vm._v("（盖章）")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "date_view" }, [
          _c("span", [_vm._v("年")]),
          _vm._v(" "),
          _c("span", [_vm._v("月")]),
          _vm._v(" "),
          _c("span", [_vm._v("日")])
        ])
      ]),
      _vm._v(" "),
      _c("td", [
        _c(
          "div",
          {
            staticStyle: {
              height: "70px",
              width: "30px",
              "writing-mode": "vertical-lr",
              margin: "auto",
              "letter-spacing": "3px",
              "text-align-last": "justify"
            }
          },
          [
            _vm._v("\n              行政机关"),
            _c("br"),
            _vm._v("任免意见\n            ")
          ]
        )
      ]),
      _vm._v(" "),
      _c("td", [
        _c("div", { staticStyle: { height: "20px" } }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "text-align": "right",
              "letter-spacing": "3px",
              "padding-right": "21px",
              "margin-bottom": "5px"
            }
          },
          [_vm._v("（盖章）")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "date_view" }, [
          _c("span", [_vm._v("年")]),
          _vm._v(" "),
          _c("span", [_vm._v("月")]),
          _vm._v(" "),
          _c("span", [_vm._v("日")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }